/**
 * Rutas que se cargan DENTRO de un iframe: la vista previa de una lección
 * (ModalVistaPrevia) y la página que arma el PDF de un libro completo.
 *
 * Ahí no va el Header ni el SideBar: el iframe vuelve a arrancar la plataforma,
 * y el chrome se alcanzaba a ver —header y menú con el cuerpo vacío, como un
 * "home" sin datos— mientras la lección terminaba de cargar.
 *
 * La comparación ignora mayúsculas a propósito: la ruta está declarada como
 * `/LibroPreview/:umaId` pero el modal arma la URL con `/libroPreview/...`, y
 * react-router empata las dos.
 */
export default function esVistaPrevia(pathname) {
    const rutas = ['libropreview', 'libropreviewcompleto']
    return (pathname || '').split('/').some(tramo => rutas.includes(tramo.toLowerCase()))
}
